import {AppAction} from '../../../appActions';
import {ContactsManagerPanelState} from './contactsManagerPanelState';
import {contactsManagerFileReducer} from './file/contactsManagerFileStateReducer';
import {ContactsManagerParametersTypesEnum} from './parameters/contactsManagerParameters';
import {contactsManagerParametersReducer} from './parameters/contactsManagerParametersReducer';
import {contactsManagerSearchReducer} from './search/contactsManagerSearchReducer';
import {ContactsManagerSearchState} from './search/contactsManagerSearchState';
import {contactsManagerSidePanelReducer} from './sidePanel/contactsManagerSidePanelReducer';
import {contactsManagerTableReducer} from './table/contactsManagerTableReducer';
import {ContactsManagerTableState} from './table/contactsManagerTableState';

export function contactsManagerPanelReducer(
  state: ContactsManagerPanelState,
  action: AppAction,
): ContactsManagerPanelState {
  return {
    ...state,
    sidePanelState: contactsManagerSidePanelReducer(state.sidePanelState, action),
    parameters: contactsManagerParametersReducer(state.parameters, action),
    fileState: contactsManagerFileReducer(state.fileState, action),
    tableState: contactsManagerTableWrapperReducer(state, action),
    searchState: contactsManagerSearchWrapperReducer(state, action),
  };
}

/*
 * Helpers.
 */

function contactsManagerTableWrapperReducer(
  state: ContactsManagerPanelState,
  action: AppAction,
): ContactsManagerTableState | undefined {
  // On the search page, we do not want to reduce for a single table.
  if (state.parameters.type === ContactsManagerParametersTypesEnum.SEARCH) {
    return undefined;
  }
  return contactsManagerTableReducer(state.tableState, action);
}

function contactsManagerSearchWrapperReducer(
  state: ContactsManagerPanelState,
  action: AppAction,
): ContactsManagerSearchState | undefined {
  // If we are not on the search page, we do not want to reduce.
  if (state.parameters.type !== ContactsManagerParametersTypesEnum.SEARCH) {
    return undefined;
  }
  return contactsManagerSearchReducer(state.searchState, action, state.parameters.tab);
}
